export default __webpack_public_path__ + "assets/pdf/EMP_GD_Patient_Guide_to_Results_Mobile_20241004_NAT-8021830_PROOF.pdf";